import { DragHandleIcon } from 'foundations-assets';
import styled from 'styled-components';
import { Flex } from '../Flex/Flex';
import { View } from '../View/View';
import { getVariantTokens } from './DragContainer.helpers';
import { useVariantCssObject } from './DragContainer.hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDragContainer = styled.div.withConfig({
  displayName: "DragContainer__StyledDragContainer",
  componentId: "sc-1t5z2d5-0"
})(({
  $variantCssStyles
}) => {
  return Object.assign({}, $variantCssStyles);
});
export const DragContainer = ({
  children,
  handleVariant = 'default'
}) => {
  const variantTokens = getVariantTokens(handleVariant);
  const variantCssStyles = useVariantCssObject(variantTokens);
  return /*#__PURE__*/_jsx(View, {
    borderStartStartRadius: "100",
    borderStartEndRadius: "100",
    borderEndStartRadius: "100",
    borderEndEndRadius: "100",
    overflow: "hidden",
    children: /*#__PURE__*/_jsxs(Flex, {
      position: "relative",
      flexDirection: "row",
      justifyContent: "start",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(StyledDragContainer, {
        $variantCssStyles: variantCssStyles,
        children: /*#__PURE__*/_jsx(DragHandleIcon, {
          size: "icon-300"
        })
      }), /*#__PURE__*/_jsx(View, {
        display: "inline-block",
        inlineSize: "100%",
        marginInlineStart: "400",
        children: children
      })]
    })
  });
};